import { useIsMobile } from '~/context/common/DeviceContext';
import useIsInMiniHeroExperiment from '~/hooks/vdp/useIsInMiniHeroExperiment';

export default function useShouldShowMiniHeroDesktop() {
  const isInMiniHeroExperiment = useIsInMiniHeroExperiment();
  const isMobile = useIsMobile();

  return isInMiniHeroExperiment && !isMobile;
}
